import moment from "moment";

/**
 * Converte uma data/hora gravada em UTC 0 (banco) para o horário de Brasília (UTC-3),
 * no formato BR. Escopo do Pagamento de Taxa — não mexe no util compartilhado, que o
 * resto do app usa com datas em horário local.
 */
export const converterUtcParaBr = (data?: string | Date | null) =>
  data && moment(data).isValid()
    ? moment.utc(data).utcOffset(-3).format("DD/MM/YYYY HH:mm:ss")
    : "-";
